import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
import Shuffle from 'shufflejs';
import GLightbox from 'glightbox';
import AOS from 'aos';
import Pikaday from 'pikaday';
import moment from 'moment';

Swiper.use([Navigation, Pagination, EffectFade]);

document.addEventListener('DOMContentLoaded', () => {
  // nav
  const mastheadMain = document.querySelector('.masthead--main');
  const hamburger = document.querySelector('.masthead--hamburger');

  document.querySelectorAll('.mobile-menu-toggle').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      mastheadMain.classList.toggle('toggled');
      hamburger.classList.toggle('toggled');
    });
  });

  const inputDates = document.querySelectorAll('.wpcf-date-picker');

  inputDates.forEach(function (inputDate) {
    if (inputDate) {
      var pikaday = new Pikaday({
        field: inputDate,
        format: 'DD.MM.YYYY',
        firstDay: 1,
        i18n: {
          months: ['Sty', 'Lu', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
          weekdays: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb'],
          weekdaysShort: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb']
        },
      });
    }
  });

  const sectionAcfHeaderBtn = document.querySelectorAll('.section-acf.section-header .btn');

  sectionAcfHeaderBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const href = btn.getAttribute('href');

      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    })
  })


  if (document.body.classList.contains('home')) {
    // aos init
    AOS.init({
      once: true,
    });

    // products sliders
    const slidersProductImg = document.querySelector(
      '.home-products--sliders-product-img'
    );

    const commonConfig = {
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
    };

    if (slidersProductImg) {
      commonConfig['navigation'] = {
        nextEl: slidersProductImg.querySelector('.swiper-button-next'),
        prevEl: slidersProductImg.querySelector('.swiper-button-prev'),
      };
    }

    document.querySelectorAll('.home-products--sliders-img').forEach((el) => {
      new Swiper(el, {
        ...commonConfig,
        effect: 'fade',
      });
    });

    document
      .querySelectorAll('.home-products--sliders-product-img')
      .forEach((el) => {
        new Swiper(el, {
          ...commonConfig,
          direction: 'horizontal',
          breakpoints: {
            992: {
              direction: 'vertical',
            },
          },
        });
      });

    document
      .querySelectorAll('.home-products--sliders-content')
      .forEach((el) => {
        new Swiper(el, {
          ...commonConfig,
          effect: 'fade',
        });
      });

    // about features
    document
      .querySelectorAll('.home-about--features')
      .forEach((aboutFeatures) => {
        new Swiper(aboutFeatures, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.2,
              spaceBetween: 32,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 32,
            },
          },
        });
      });

    // recipe slider
    document
      .querySelectorAll('.home-recipes--items-slider')
      .forEach((recipesItems) => {
        new Swiper(recipesItems, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          loop: true,
          breakpoints: {
            768: {
              slidesPerView: 2.2,
              spaceBetween: 32,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 32,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
          },
        });
      });
  } else if (
    document.body.classList.contains('page-template-template-career')
  ) {
    // intro link
    const offers = document.querySelector('.page-career--offers');
    document
      .querySelector('.page-career--intro-main a')
      .addEventListener('click', (e) => {
        e.preventDefault();

        offers.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      });

    // stories slider
    const sliderWrapper = document.querySelector(
      '.page-career--stories-items-slider'
    );

    new Swiper(sliderWrapper, {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  } else if (
    document.body.classList.contains('page-template-template-who-we-are')
  ) {
    // features slider
    document
      .querySelectorAll('.page-who-we-are--features-items')
      .forEach((features) => {
        new Swiper(features, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.2,
              spaceBetween: 32,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 32,
            },
          },
        });
      });

    // sliders
    document
      .querySelectorAll('.page-who-we-are--slider-items')
      .forEach((sliderWrapper) => {
        new Swiper(sliderWrapper, {
          slidesPerView: 1.7,
          navigation: {
            nextEl: sliderWrapper.querySelector('.swiper-button-next'),
            prevEl: sliderWrapper.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 2.7,
            },
            992: {
              slidesPerView: 4.4,
            },
          },
        });
      });
  } else if (document.body.classList.contains('page-template-template-esg')) {
    document.querySelectorAll('.page-esg--slider-items').forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 32,
          },
          1200: {
            slidesPerView: 3.2,
            spaceBetween: 32,
            navigation: {
              nextEl: slider.parentNode.querySelector('.swiper-button-next'),
              prevEl: slider.parentNode.querySelector('.swiper-button-prev'),
            },
          },
        },
      });
    });
  } else if (
    document.body.classList.contains('page-template-template-products')
  ) {
    const categoriesWrapper = document.querySelector(
      '.page-products--categories'
    );
    const categories = document.querySelectorAll('li');
    const subcategories = document.querySelector(
      '.page-products--subcategories'
    );
    const productsShuffle = new Shuffle(subcategories, {
      itemSelector: '.page-products--subcategory',
      sizer: '.page-products--subcategories-sizer',
    });

    let filtered = false;

    document
      .querySelectorAll('.page-products--categories button')
      .forEach((button) => {
        const { name: categorySlug } = button.dataset;

        button.addEventListener('click', (e) => {
          e.preventDefault();

          if (!filtered) {
            categoriesWrapper.classList.add('filtered');

            filtered = true;
          } else {
            if (categorySlug === 'all') {
              categoriesWrapper.classList.remove('filtered');

              filtered = false;
            }
          }

          categories.forEach((category) => {
            category.classList.remove('active');
          });

          button.parentElement.classList.add('active');

          productsShuffle.filter(categorySlug);

          // path manipulation
          const categoryString =
            document.querySelector('.current-lang').textContent === 'pl'
              ? 'kategorie'
              : 'categories';

          if (
            !window.location.pathname.includes(
              `/${categoryString}/${categorySlug}/`
            )
          ) {
            const currentPath = window.location.pathname;
            const currentPathSplitted = currentPath.split('/');

            if (categorySlug !== 'all') {
              if (
                window.location.pathname.includes('/kategorie/') ||
                window.location.pathname.includes('/categories/')
              ) {
                currentPathSplitted.splice(-3, 3);
                window.history.pushState(
                  'product-category',
                  '',
                  `${currentPathSplitted.join(
                    '/'
                  )}/${categoryString}/${categorySlug}/`
                );
              } else {
                window.history.pushState(
                  'product-category',
                  '',
                  `${currentPathSplitted.join(
                    '/'
                  )}${categoryString}/${categorySlug}/`
                );
              }
            } else {
              if (
                window.location.pathname.includes('/kategorie/') ||
                window.location.pathname.includes('/categories/')
              ) {
                currentPathSplitted.splice(-3, 3);
                window.history.pushState(
                  'product-category',
                  '',
                  `${currentPathSplitted.join('/')}/`
                );
              }
            }
          }
          subcategories.scrollIntoView({
            behavior: 'smooth',
          });
        });
      });

    // url-selected category
    const selectedCategorySlugInput = document.getElementById(
      'selected_category_slug'
    );

    if (selectedCategorySlugInput) {
      const selectedCategorySlug = selectedCategorySlugInput.value;

      const maybeSelectedCategoryElement = document.querySelector(
        `.page-products--categories [data-name=${selectedCategorySlug}]`
      );

      if (maybeSelectedCategoryElement) {
        maybeSelectedCategoryElement.click();
      }
    }

    // lightbox
    const lightbox = GLightbox();

    document
      .querySelectorAll('.page-products--subcategory-item')
      .forEach((el) => {
        const subcategoryItems = Array.from(
          el.parentElement.querySelectorAll(':scope > div')
        );

        const elementIndex = subcategoryItems.indexOf(el);
        const { slug } = el.dataset;

        const lightboxElements = subcategoryItems.map((item) => {
          const { title, desc, cu, productImgUrl } = item.dataset;

          const cuHtml = cu
            .split(';')
            .map((el) => `<li>${el}</li>`)
            .join('');

          const modalTemplate = `
        <div class="product-modal">
          <div class="product-modal--img">
            <img src="${productImgUrl}" alt="${title}">
          </div>
          <div class="product-modal--data">
            <h3>${title}</h3>
            <div class="product-modal--data-desc">${desc}</div>
            <div class="product-modal--data-cu">
              <svg xmlns="http://www.w3.org/2000/svg" width="71.375" height="81.501" viewBox="0 0 71.375 81.501"><g transform="translate(166.415 -47.585)"><path d="M-103.194,118.746H-159.5a5.083,5.083,0,0,1-5.008-5.954l7.58-43.579A5.082,5.082,0,0,1-151.922,65h41.149a5.082,5.082,0,0,1,5.007,4.212l7.58,43.579A5.083,5.083,0,0,1-103.194,118.746Z" transform="translate(0.231 8.926)" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.83"/><g transform="translate(-137.348 61.463)"><line y1="12.463" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.83"/><line y1="12.463" transform="translate(12.463)" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.83"/></g><path d="M0,0H68.545a0,0,0,0,1,0,0V4.463a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z" transform="translate(-165 49)" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.83"/><circle cx="15.578" cy="15.578" r="15.578" transform="translate(-146.306 84.83)" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.83"/><circle cx="3.2" cy="3.2" r="3.2" transform="translate(-133.928 97.208)" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.83"/><line y1="4.174" x2="4.174" transform="translate(-128.464 93.972)" fill="none" stroke="#f8f2e8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.83"/></g></svg>
              <ul>${cuHtml}</ul>
            </div>
          </div>
        </div>
        `;

          return {
            content: modalTemplate,
            width: '900px',
            height: '80vh',
          };
        });

        el.addEventListener('click', () => {
          lightbox.setElements(lightboxElements);

          const currentPath = window.location.pathname;

          if (!currentPath.includes(slug)) {
            const newPath = `${currentPath}${slug}/`;

            window.history.pushState('product-slug', '', newPath);
          }

          lightbox.openAt(elementIndex);
        });
      });

    lightbox.on('close', () => {
      const currentPath = window.location.pathname;
      const newPath = currentPath.split('/');
      newPath.pop();
      newPath.pop();
      const newPathJoined = newPath.join('/');

      window.history.pushState('product-index', '', `${newPathJoined}/`);
    });

    // url-selected product
    const selectedProductSlugInput = document.getElementById(
      'selected_product_slug'
    );

    if (selectedProductSlugInput) {
      const selectedProductSlug = selectedProductSlugInput.value;

      const maybeSelectedProductElement = document.querySelector(
        `[data-slug=${selectedProductSlug}]`
      );

      if (maybeSelectedProductElement) {
        maybeSelectedProductElement.click();
      }
    }
  } else if (document.body.classList.contains('single-product')) {
    document
      .querySelectorAll('.content-single-product--related-items-slider')
      .forEach((recipesItems) => {
        new Swiper(recipesItems, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.2,
              spaceBetween: 32,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 32,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 32,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
          },
        });
      });
  } else if (document.body.classList.contains('single-post')) {
    if (document.querySelector('.glightbox')) {
      GLightbox();
    }
  }
});
